import { Injectable } from "@angular/core";
import { RetrievePfGeosUseCase } from "../../../../domain/use-cases/hr/retrieve-pfgeos.usecase";

import { HttpClient } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { CreateFakeResourcePayload } from "../../../../domain/models/contract-resource.model";
import { Resource } from "../../../../domain/models/personnel.model";
import { CreateFakeResourceUseCase } from "../../../../domain/use-cases/hr/create-fake-resource.usecase";
import { FreezeCostsUseCase } from "../../../../domain/use-cases/hr/freeze-costs.usecase";
import { GetAllDisciplinesUseCase } from "../../../../domain/use-cases/hr/hierarchies/get-all-disciplines.usecase";
import { GetAllFigureUseCase } from "../../../../domain/use-cases/hr/hierarchies/get-all-figures.usecase";
import { GetAllGeosUseCase } from "../../../../domain/use-cases/hr/hierarchies/get-all-geos.usecase";
import { GetAllPracticesUseCase } from "../../../../domain/use-cases/hr/hierarchies/get-all-practices.usecase";
import { RetrieveContractResourceModalDataUseCase } from "../../../../domain/use-cases/hr/retrieve-contract-resource-modal-data.usecase";

@Injectable({
  providedIn: "root",
})
export class HrService {
  constructor(
    private getAllPracticesUseCase: GetAllPracticesUseCase,
    private getAllDisciplinesUseCase: GetAllDisciplinesUseCase,
    private getAllFiguresUseCase: GetAllFigureUseCase,
    private getAllGeosUseCase: GetAllGeosUseCase,
    private retrievePfGeosUseCase: RetrievePfGeosUseCase,
    private retrieveContractResourceModalDataUseCase: RetrieveContractResourceModalDataUseCase,
    private createFakeResourceUseCase: CreateFakeResourceUseCase,
    private freezeCostUseCase: FreezeCostsUseCase,
    private http: HttpClient,
  ) {}

  getAllPractices() {
    return this.getAllPracticesUseCase.execute();
  }

  getAllDisciplines() {
    return this.getAllDisciplinesUseCase.execute();
  }

  getAllFigures() {
    return this.getAllFiguresUseCase
      .execute()
      .pipe

      // exhaustMap((res) => from(res)),
      // filter((fp) => fp.isSmart!),
      // toArray(),
      ();
  }

  getAllGeos() {
    return this.getAllGeosUseCase.execute();
  }

  retrieveContractResourceModalData(startDate: string, endDate: string) {
    return this.retrieveContractResourceModalDataUseCase.execute({
      startDate: startDate,
      endDate: endDate,
    });
  }

  createFakeResource(param: CreateFakeResourcePayload): Observable<Resource> {
    return this.createFakeResourceUseCase.execute(param);
  }
  getAllRoles() {
    return this.http
      .get<any>(`${environment.apiUrl}/hr/roles`)
      .pipe(map((response) => response.roles));
  }

  getAllPfGeos() {
    return this.retrievePfGeosUseCase.execute();
  }

  getFrozenCosts(param: number) {
    return this.freezeCostUseCase.execute(param);
  }
}
